import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-717a716c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "graph" }
const _hoisted_2 = { class: "amount-text" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = { class: "amount-column" }
const _hoisted_5 = { class: "amount-text" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " X ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localStats.winDistribution.entries(), (entry) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "amount-column",
        key: entry
      }, [
        _createElementVNode("div", {
          class: "bar",
          style: _normalizeStyle(_ctx.getBarStyle(entry[1]))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(entry[1]), 1)
        ], 4),
        _createElementVNode("span", _hoisted_3, _toDisplayString(entry[0]), 1)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "bar",
        style: _normalizeStyle(_ctx.getBarStyle(_ctx.localStats.amountOfLosses, true))
      }, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.localStats.amountOfLosses), 1)
      ], 4),
      _hoisted_6
    ])
  ]))
}